import { ReturnAddress } from "../types/evidence";

export const EMPTY_ADDRESS: ReturnAddress = { address_line_1: '', admin_area_2: '', admin_area_1: '', postal_code: '', country_code: '' };

export const addressIncomplete = (address: ReturnAddress) =>
  Object.values(address).some((v) => !v.trim()) || !/^[A-Za-z]{2}$/.test(address.country_code.trim());
